import { IMaster, RestaurationConfiguration } from '../IMaster';
import { IMasterSync } from '../IMasterSync';
import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { P00039, P00039Data } from '../edro/P00039';

export class P00077 extends IMaster {
  getUpdateTuto(): ProductTuto {
    throw new Error('Method not implemented.');
  }

  override deviceTableIndex: number = 0;

  override dataIdentifier?: string = 'master';

  override modelIdentifier?: string = 'P00077';

  override manufacturerName?: string = 'EUROPISCINE';

  override deviceTable: any = null;

  data: P00039Data = new P00039Data();

  constructor() {
    super();

    this.deviceTable = {
      syncMode: 0,
    };
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00039;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  resetAddProduct() {
    return new P00039().resetAddProduct();
  }

  addProduct(pool: Pool, product: IProduct) {
    return new P00039().addProduct(pool, product);
  }

  saveAll() {
    return new P00039().saveAll();
  }

  hasProduct(pool: Pool, product: IProduct): number {
    return new P00039().hasProduct(pool, product);
  }

  hasAlarm(): boolean {
    return false;
  }

  hasConnect(pool: Pool) {
    return new P00039().hasConnect(pool);
  }

  removeProduct(pool: Pool, product: IProduct) {
    return new P00039().removeProduct(pool, product);
  }

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00039/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00039/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00039/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getManager(): IMasterSync {
    return new P00039().getManager();
  }

  getProductTuto(): ProductTuto {
    return {};
  }

  getCPSConfig(): CPSConfig | null {
    return new P00039().getCPSConfig();
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return new P00039().getEventProductFunctionalities();
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    return new P00039().getCPSConfigByFonctionnality(functionnality);
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return new P00039().getPropertyForOTAUpdate();
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return new P00039().getMinimumFirmwareVersionForBleUpdate();
  }

  needConfiguration(pool: Pool): boolean {
    return new P00039().needConfiguration(pool);
  }

  restaurationConfiguration(): RestaurationConfiguration[] {
    return new P00039().restaurationConfiguration();
  }

  getProductVideoURI(langCode: string): string | null {
    return new P00039().getProductVideoURI(langCode);
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return new P00039().getProductVideoChapterURI(langCode);
  }
}
